import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import {
  PageWrapper,
  StepperFormStore,
  UnsavedChangesGuardedComponent,
  useFirmwareStore
} from '@ottobock/remote-update/domain';
import { LogService } from '@ottobock/shared/domain';

import { CreateFirmwarePackage } from '../firmware-modal/create-firmware-package';
import { FirmwareTableComponent } from '../firmware-table/firmware-table.component';

@Component({
  standalone: true,
  selector: 'remote-update-feature-remote-update-dashboard-firmware-page',
  imports: [
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    FirmwareTableComponent,
    MatProgressBarModule,
    PageWrapper,
    MatProgressBarModule
  ],
  templateUrl: './firmware-page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './firmware-page.scss'
})
export class FirmwarePage implements UnsavedChangesGuardedComponent, OnInit {
  readonly dialog = inject(MatDialog);
  firmwareStore = inject(useFirmwareStore);
  firmwareStepperFormStore = inject(StepperFormStore);
  logService = inject(LogService);

  emptyTitle = 'No firmware package available';
  emptyDescription = 'Please create a new firmware package';
  unsavedChangesMessage =
    'If you leave now, your progress will be lost and no firmware package will be created.';

  data = computed(() => this.firmwareStore.allPackages().data ?? []);
  hasError = computed(() => this.firmwareStore.allPackages().error !== null);
  isLoading = computed(() => this.firmwareStore.allPackages().loading);

  backRedirectRoute = '/firmware-package';

  get hasUnsavedChanges() {
    return this.firmwareStepperFormStore.isFormDirty();
  }

  ngOnInit(): void {
    this.firmwareStore.loadAllPackages();
  }

  openDialog() {
    this.firmwareStepperFormStore.resetStore();
    const dialogRef = this.dialog.open(CreateFirmwarePackage, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      data: { name: 'John Doe' },
      disableClose: true,
      closeOnNavigation: false,
      panelClass: 'no-radius-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.firmwareStepperFormStore.resetStore();
    });
  }
}
